import { Component, OnInit, Input, Output, EventEmitter, signal, input, effect } from '@angular/core';
import { RuleCondition } from '../../classes/rule-service/rule-condition';
import { Site } from '../../classes/site';
import { Gateway } from '../../classes/gateway';
import { RuleAction } from '../../classes/rule-service/rule-action';
import { AdminExportService } from 'app/shared/admin-export.service';
import { APIService } from 'app/shared/api.service';

@Component({
  selector: 'app-rule-action-picker',
  templateUrl: './rule-action-picker.component.html',
  styleUrls: ['./rule-action-picker.component.css'],
  standalone: false
})
export class RuleActionPickerComponent implements OnInit {

  @Output()
  submit: EventEmitter<RuleAction> = new EventEmitter<RuleAction>();

  @Output()
  cancel: EventEmitter<any> = new EventEmitter<any>();

  _modifyAction: RuleAction;

  @Input()
  public set modifyAction(value: RuleAction) {
    if (value) {
      this._modifyAction = value;
      this.action = 'modify';
    }
  }

  action: any;
  details: string;

  @Input()
  defaultGateway: Gateway;

  @Input()
  defaultSite: Site;

  rulePackage = input<any>(null);

  operate = signal<boolean>(false);

  equpiment = signal<any>(null);
  payloads = signal<any[]>(null);

  newAlarmRasied = signal<boolean>(true);
  resolvedlarm = signal<boolean>(true);

  trigger: ActionState = null;

  actionStates = [
    { id: 'new', title: 'New Alarm' },
    { id: 'delayed', title: 'Delayed Alarm' },
    { id: 'paused', title: 'Paused Alarm' },
    { id: 'resolved', title: 'Resolved Alarm' }
  ];

  actionStatesFiltered = signal<any[]>(null);
  actionStateDefault = signal<ActionState>('new');
  constructor(private adminExportService: AdminExportService, private apiService: APIService) {

    effect(() => {
      // Accessing the signal value creates a reactive dependency
      const currentActions = this.rulePackage()?.actions;
      console.log(currentActions);
      this.changed()
    });
  }

  ngOnInit() {
    this.changed();
  }

  changed() {
    this.actionStatesFiltered.set(this.actionStates.filter(as => !this.rulePackage()?.actions.some(a => a.trigger === as.id)));
    this.actionStateDefault.set(this.actionStatesFiltered().filter(as => as.id !== 'delayed' && as.id !== 'paused')[0]?.id ?? this.actionStatesFiltered()[0]?.id);

    if (this.trigger === null) {
      this.trigger = this.actionStateDefault();
    }
  }

  triggerSelected(trigger: ActionState) {
    console.log(trigger);
    this.trigger = trigger;
  }

  deviceActionClick(eq) {
    console.log(`deviceActionClick`, eq);
    this.operate.set(null);
    const action = new RuleAction({
      method: 'operate',
      trigger: this.trigger, device_action_id: eq.id,
      device_title: eq.device.title,
      device_action_title: eq.title, device_action_gateway_id: eq.device.gatewayId
    });

    this.submit.emit(action);
  }

  newAction(typeOfCondition: string) {
    this.trigger = null;
    switch (typeOfCondition) {
      case 'operate':
        this.operate.set(true);
        this.adminExportService.getActionsForRulesInOrg(this.apiService.getUserOrg().id).then((actions) => {
          this.equpiment.set(actions);
          this.changed();
        });
        break;
      default:
        this.operate.set(false);
        this.action = { action: 'new', type: typeOfCondition };
        this.details = 'New Condition';
        break;
    }
    this.changed();
  }

  newRuleActionSubmitted(action: RuleAction) {
    this.action = null;
    this.submit.emit(action)
  }

  newRuleActionCancelled() {
    this.action = null;
    this.cancel.emit();
  }

  newRuleHours() {
    this.action = 'restrict-hours';
  }
}

export type ActionState = 'new' | 'delayed' | 'paused' | 'resolved';
